export const apartamentosInitialState = {
  apartamentos: [],
  novoApartamento: [],
  apartamentoRemovido: [],
  apartamento: [],
  apartamentoEditado: [],
  limpezas: [],
};
